<template>
  <div class="fromListNe">
    <div
      class="rightfor"
      ref="left"
      :style="{
        backgroundColor: '#e2ebf1',
        width: treeHidder == true ? '10px' : '',
        height: '100%',
      }"
    >
      <tree
        :treedata="treeData"
        @Afffor="Afffor"
        :dataobjs="dataobjs"
        :fly-tay="flyTay"
        :tree-hidder="treeHidder"
        :keystree="keystree"
        :style="{ width: treeHidder == true ? 0 : '' }"
      />
      <div class="newimgList_Warp" @click="isShowFly">
        <img src="@/assets/img/xiaz.png" alt />
      </div>
    </div>
    <div class="leftNNert" :style="{ width: treeHidder == true ? '99%' : '85%' }">
      <div class="flyTabl_ind">
        <el-button type="primary" @click="bindClickCalse" :disabled="valueUiid==''">
          <i class="el-icon-edit-outline"></i>{{dataobjs.tianjiashexiangtou}}
        </el-button>
        <div style="padding:0 20px" v-if="optionsChiiend.length != 0">
          <span style="margin: 0 3px; display: inline-flex">{{dataobjs.qingxuanzewangquyu}}:</span>
          <el-select
            v-model="valueUiid"
            placeholder="请选择区域"
            @change="mychange"
            style="height: 20px"
          >
            <el-option :key="0" label="全部" :value="0" v-if="optionsChiiend.length > 1"></el-option>
            <el-option
              v-for="item in optionsChiiend"
              :key="item.uuid"
              :label="item.areaname"
              :value="item.uuid"
            ></el-option>
          </el-select>
        </div>
      </div>
      <el-table
        :data="tableData"
        :row-class-name="tableRowClassName"
        :max-height="heagintH"
        :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
        border
      >
        <el-table-column prop="name" :label="dataobjs.shexiangtoumingcheng" fixed width="150"></el-table-column>
        <el-table-column
          prop="deviceserial"
          :label="dataobjs.shebeixuliehao"
          :show-overflow-tooltip="true"
          width="100"
        ></el-table-column>
        <el-table-column prop="enable" :label="dataobjs.luzhikaiguan">
          <template slot-scope="{row}">
            <el-link :type="row.enable == 0 ?'danger':'primary'">{{row.enable == 0?'关闭':'开启'}}</el-link>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="isdefence" :label="dataobjs.buchenfangzhuangtai" width="100">
          <template slot-scope="{row}">
            <el-link :type="row.isdefence == 0 ?'danger':'primary'">{{row.isdefence == 0?'撤防':'布防'}}</el-link>
          </template>
        </el-table-column> -->
        <!-- <el-table-column prop="type" :label="dataobjs.shexiangtouleixing" width="100">
          <template slot-scope="{row}">
            <el-link :type="row.type == 1 ?'danger':'primary'">{{row.type == 1?'萤石云 ':'海康'}}</el-link>
          </template>
        </el-table-column> -->
        <!-- <el-table-column prop="captureflag" :label="dataobjs.dingshizhuapai">
          <template slot-scope="{row}">
            <el-link
              :type="row.captureflag == 0 ?'danger':'primary'"
            >{{row.captureflag == 0?'否 ':'是'}}</el-link>
          </template>
        </el-table-column> -->
        <el-table-column prop="capturetime" :label="dataobjs.zhuapaizhouqi" width="120"></el-table-column>
        <el-table-column prop="status" :label="dataobjs.shifouzaixian">
          <template slot-scope="{row}">
            <el-link :type="row.status == 1 ?'primary':'danger'">{{row.status == 1?'在线 ':'不在线'}}</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="onlinetime" :label="dataobjs.shangxianshijian" width="120"></el-table-column>
        <el-table-column :label="dataobjs.caozuo" width="200" fixed="right">
          <template slot-scope="{ row }">
            <el-button
              size="mini"
              round
              icon="el-icon-edit"
              type="primary"
              @click="editFrom(row)"
            >{{dataobjs.xiugai}}</el-button>
            <!--    -->
            <el-button
              size="mini"
              type="danger"
              @click="deleData(row)"
              icon="el-icon-delete"
              round
            >{{dataobjs.shanchu}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <page-helper :page-data="pageData" :total="total" :get-table-list="PostJsonData"></page-helper>
    </div>

    <!-- 添加摄像头 -->
    <el-dialog
      :title="title_T"
      :visible.sync="dialogVisibleCamers"
      width="50%"
      :modal="false"
      :close-on-click-modal="false"
    >
      <Add :rule-form="ruleForm" :hide-clone="hideClone" @arend_sup="arend_sup" :dataobjsend="dataobjs" />
    </el-dialog>
  </div>
</template>
<script>
import { treeinfo, lang_fend, dealerDelete } from "@/network/index";
import { Camers_Dom, Camers_Data } from "@/network/lineRequest";
import PageHelper from "@/components/common/PageHelper";
import tree from "@/components/common/tree";
import Add from "./components/add";
export default {
  components: {
    PageHelper,
    tree,
    Add,
  },
  data() {
    return {
      title_T:'',
      treeHidder: false,
      dataJson: {},
      lang_file: sessionStorage.getItem("lang_file"),
      flyNameList: sessionStorage.getItem("roletypeValue"),
      textContent: "正在努力加载中...",
      tableData: [], //table数据
      loading: true,
      dataobjs: {}, //翻译
      treeData: [], //树形结构数据
      pageData: {
        pagenum: 1, //页码  pagenum  2
        pagesize: 30, //数据   pagesize几条数据
      },
      keystree: [],
      optionsChiiend: [], //下拉框数据
      total: null,
      flyTay: false,
      valueUiid: "",
      dialogVisibleCamers: false, //摄像头弹出框
      ruleForm: {
        area_uuid: "",
        name: "",
        deviceserial: "",
        validatecode: "",
        enable: "0", //录制开关 0 关闭 1开启
        // isdefence: "0", //0-撤防，1-布防
        // type: "1", //摄像头状态 1:萤石云 2：海康
        captureflag: "0", //0 否 1 是
        capturetime: "0", //抓拍周期（分钟）
        status: "0", //是否在线 0 否 1是
        onlinetime: "", //上线时间
        remark: "", //备注
      },
      flyQV: "",//判断是省市区 经销商 客户 区域 网关
      End_value: "",//获取点击的uuid
    };
  },
  computed: {
    heagintH() {
      return window.innerHeight - 200;
    },
  },
  mounted() {
    this.treeinfo();
    this.PostJsonData(); //获取默认摄像头信息
    this.lang_fend();
  },
  methods: {
    // 修改
    editFrom(row) {
      this.title_T = this.dataobjs.xiugai
      this.ruleForm = { ...row };
      this.dialogVisibleCamers = true;
    },
    // 删除
    deleData(e) {
      //   this.CamearSetData()
      let fly =
        this.flyQV == "区"
          ? "countycode"
          : this.flyQV == "省"
          ? "provincecode"
          : this.flyQV == "市"
          ? "citycode"
          : this.flyQV == "经"
          ? "dealer_uuid"
          : this.flyQV == "客户"
          ? "customer_uuid"
          : this.flyQV == "网"
          ? "area_uuid"
          : "";
      let tablename = "tb_monitor";
      this.$confirm(`${this.dataobjs.quedingyaoshanchu}`, `${this.dataobjs.tishi}`, {
        confirmButtonText: `${this.dataobjs.queding}`,
        cancelButtonText: `${this.dataobjs.quxiao}`,
        closeOnClickModal: false,
        type: "warning",
      })
        .then(async () => {
          const { code, msg } = await dealerDelete(e.uuid, tablename);
          if (code) {
            let dataL = {
              pagenum: this.pageData.pagenum,
              pagesize: this.pageData.pagesize,
            };
            dataL[fly] = this.End_value
            this.CamearSetData(dataL);
            this.$message({
              type: "success",
              message: msg,
            });
          } else {
            this.$message.error(msg);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.dataobjs.yiquxiaoshanchu}`,
          });
        });
    },
    // 添加摄像头
    bindClickCalse() {
      this.title_T = this.dataobjs.tianjiashexiangtou
        // this.ruleForm.area_uuid = this.End_value
      this.dialogVisibleCamers = true;
    },
    // 关闭摄像头
    hideClone() {
      this.ruleForm = {
        name: "",
        deviceserial: "",
        validatecode: "",
        enable: "0", //录制开关 0 关闭 1开启
        // isdefence: "0", //0-撤防，1-布防
        // type: "1", //摄像头状态 1:萤石云 2：海康
        captureflag: "0", //0 否 1 是
        capturetime: "0", //抓拍周期（分钟）
        status: "0", //是否在线 0 否 1是
        onlinetime: "", //上线时间
        remark: "", //备注
      };
      this.dialogVisibleCamers = false;
    },
    // 下拉框事件
    mychange(e) {
      this.ruleForm.area_uuid = e;
      this.End_value = e;
      this.flyQV = "网";
      let area_uuid = {
        area_uuid: e,
        pagenum: this.pageData.pagenum,
        pagesize: this.pageData.pagesize,
      };
      this.CamearSetData(area_uuid);
    },
    //更新table列表，点击确定后
    arend_sup(e) {
      let area_uuid = {
        area_uuid: e,
        pagenum: this.pageData.pagenum,
        pagesize: this.pageData.pagesize,
      };
      this.CamearSetData(area_uuid);
    },
    //获取列表默认摄像头信息
    async PostJsonData() {
      const { code, data } = await Camers_Dom(this.pageData);
      let { list, pagelist } = data;
      let keys = data.default; //获取默认展开的树形结构
      let keyCurrindex = keys.length;
      this.keystree.push(keys[keyCurrindex - 1].uuid);

      // table数据
      this.tableData = list;
      this.total = Number(pagelist[0].allpage);
    },
    // 翻译
    async lang_fend() {
      let page = "monitor_page";
      let objs = {
        page,
        lang_file: this.lang_file,
      };
      const { data, code } = await lang_fend(objs);
      console.log(data);
      
      this.dataobjs = data;
    },
    // 根据滚动条滚动
    Afffor(e) {
      // setTimeout(() => {
      //   var element = this.$refs.left;
      //   element.scrollIntoView();
      //   element.scrollIntoView(true);
      //   for (let i = 0; i < 6; i++) {
      //     element.scrollIntoView({ block: "end" });
      //   }
      //   element.scrollIntoView({
      //     behavior: "smooth",
      //     block: "end",
      //     inline: "nearest",
      //   });
      // }, 500);

      /**
       * 获取树的省市区县 经销商 客户
       */
      switch (e.fieldname) {
        case "city": //区
          this.flyQV = "区";
          this.End_value = e.uuid;
          let countycode = {
            countycode: e.uuid,
            pagenum: this.pageData.pagenum,
            pagesize: this.pageData.pagesize,
          };
          this.CamearSetData(countycode);
          break;
        case "province":
          this.flyQV = "省";
          this.End_value = e.uuid;
          let provincecode = {
            provincecode: e.uuid,
            pagenum: this.pageData.pagenum,
            pagesize: this.pageData.pagesize,
          };
          this.CamearSetData(provincecode);
          break;
        case "county": //市
          this.flyQV = "市";
          this.End_value = e.uuid;
          let citycode = {
            citycode: e.uuid,
            pagenum: this.pageData.pagenum,
            pagesize: this.pageData.pagesize,
          };
          this.CamearSetData(citycode);
          break;
      }

      if (e.dealer_uuid) {
        //经销商
        this.flyQV = "经";
        this.End_value = e.dealer_uuid;
        let dealer_uuid = {
          dealer_uuid: e.dealer_uuid,
          pagenum: this.pageData.pagenum,
          pagesize: this.pageData.pagesize,
        };
        this.CamearSetData(dealer_uuid);
      } else if (e.customer_uuid) {
        this.flyQV = "客户";
        this.End_value = e.customer_uuid;
        let customer_uuid = {
          customer_uuid: e.customer_uuid,
          pagenum: this.pageData.pagenum,
          pagesize: this.pageData.pagesize,
        };
        this.CamearSetData(customer_uuid);
      }
    },
    // 获取摄像头信息
    async CamearSetData(uuid_data) {
      const { code, data } = await Camers_Data(uuid_data);
      console.log(data);
      let { list, pagelist, arealist } = data;
      // table数据
      this.tableData = list;
      this.total = Number(pagelist[0].allpage);

      if (arealist != undefined) {
        this.optionsChiiend = arealist; //下拉框的数据
        this.valueUiid = arealist.length == 1 ? arealist[0].uuid : 0; //判断如果下拉框里面只有一个数就显示那个值，如果是多个值就显示全部
        this.ruleForm.area_uuid = arealist[0].uuid;
        console.log( this.ruleForm.area_uuid,"2222")
      }
    },
    // 树折叠
    isShowFly() {
      this.treeHidder = !this.treeHidder;
    },
    // 搜索功能
    serchBten(e) {
      this.flyTay = true;
      this.treeinfo(e);
    },
    // 树形结构
    async treeinfo(search) {
      let levelid = 2;
      const { code, data, msg } = await treeinfo(levelid, search);
      if (code) {
        this.treeData = data;
      }
    },
    tableRowClassName({ row, rowIndex }) {
      let index = rowIndex + 1;
      if (index % 2 == 0) {
        return "warning-row";
      } else {
        return "success-row";
      }
    },
  },
};
</script>
<style >
.el-dialog__wrapper {
  z-index: 1000 !important;
}
.contHeader {
  display: flex;
}
.fromListNe {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  position: relative;
}
.rightfor {
  width: 257px;
  height: 100%;
  overflow: auto;
}
.leftNNert {
  /* flex: 80%; */
  width: 80%;
  height: 500px;
  /* overflow: auto; */
  padding: 0 10px;
}
.storch {
  display: flex;
  padding-bottom: 15px;
}
.storch button {
  margin: 0 10px;
}
.newimgList_Warp {
  position: absolute;
  left: 0;
  top: 50%;
}
.flyTabl_ind {
  display: flex;
  padding: 10px 0;
  align-items: center;
}
</style>
